import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { component_identity } from "abreact/core/identity/IdentityUtils";
import { LocallyUniqueIdSet } from "abweb/utils/LocallyUniqueIdSet";

/**
 * Identifies a component that has an identity, which may be as simple as a name
 */

/**
 * Class used to establish sequencing of component children
 */
export class ComponentSequencer {
  constructor() {
    _defineProperty(this, "_sequenceMap", new Map());
  }
  getSequence(componentIdentifier) {
    let sequence = this._sequenceMap.get(componentIdentifier);
    if (sequence === undefined) {
      this._sequenceMap.set(componentIdentifier, 1);
      sequence = 0;
    } else {
      this._sequenceMap.set(componentIdentifier, sequence + 1);
    }
    return sequence;
  }
  remove(component) {
    let componentIdentifier = component[component_identity].componentIdentifier;
    if (componentIdentifier) {
      const currentSequence = this._sequenceMap.get(componentIdentifier);
      if (currentSequence !== undefined) {
        if (currentSequence === 1) {
          this._sequenceMap.delete(componentIdentifier);
        } else {
          this._sequenceMap.set(componentIdentifier, currentSequence - 1);
        }
      }
    }
  }
}
/**
 * Class used to store identity of a component and other key attributes.
 */
export class ComponentIdentity {
  constructor(name, qualifiedId, parentIdentity, loggableWarning) {
    _defineProperty(this, "_sequencer", void 0);
    _defineProperty(this, "_parent", null);
    _defineProperty(this, "loggableWarning", void 0);
    _defineProperty(this, "uniqueId", ComponentIdentity.idSet.generateId());
    this.name = name;
    if (qualifiedId) {
      this._qualifiedId = qualifiedId;
    }
    this._sequencer = new ComponentSequencer();
    this._parent = parentIdentity ?? null;
    this.loggableWarning = loggableWarning;
  }
  static createPageLevelIdentity() {
    return new ComponentIdentity("Page", "Page");
  }
  get componentIdentifier() {
    return this._componentIdentifier;
  }
  set componentIdentifier(value) {
    this._componentIdentifier = value;
  }
  set qualifiedId(value) {
    this._qualifiedId = value;
  }
  get qualifiedId() {
    return this._qualifiedId;
  }
  get name() {
    return this._name;
  }
  set name(value) {
    this._name = value;
  }
  get sequencer() {
    return this._sequencer;
  }
  set sequencer(value) {
    this._sequencer = value;
  }
  get parent() {
    return this._parent;
  }
  set parent(value) {
    this._parent = value;
  }
  get key() {
    return this._key;
  }
  set key(value) {
    this._key = value;
  }
}
_defineProperty(ComponentIdentity, "idSet", new LocallyUniqueIdSet());
//# sourceMappingURL=ComponentIdentity.js.map
